export default __webpack_public_path__ + "static/media/NoProducts.3414c6b8.svg";